export default __webpack_public_path__ + "static/home_hero-4d701fc989f48a2345772d84af261454.png";